<swal
    #swal
    [showConfirmButton]="false"
    [showCloseButton]="true"
    [customClass]="{ popup: 'custom-swal-popup PMethodinfo insuranceInfo' }"
>
    <div *swalPortal="undefined">
        <h2 class="swal2-title">
            {{ 'fe_details_step3_modal_insurance_info_h2_title' | translate }}
        </h2>
        <div class="modal__info">
            <p class="modal__intro text-start">
                {{
                    'fe_details_step3_modal_insurance_info_p_intro' | translate
                }}
            </p>
            <p class="modal__subtitle text-start">
                <b
                    ><span aria-hidden="true">✓ </span
                    >{{
                        'fe_details_step3_modal_insurance_info_p_subtitle_online'
                            | translate
                    }}</b
                >
            </p>
            <p class="modal__description text-start">
                {{
                    'fe_details_step3_modal_insurance_info_p_description_online'
                        | translate
                }}
            </p>
            <p class="modal__subtitle text-start">
                <b
                    ><span aria-hidden="true">✓ </span
                    >{{
                        'fe_details_step3_modal_insurance_info_p_subtitle_office'
                            | translate
                    }}</b
                >
            </p>
            <p class="modal__description text-start">
                {{
                    'fe_details_step3_modal_insurance_info_p_description_office'
                        | translate
                }}
            </p>
        </div>
    </div>
</swal>
